let settings = window.AnysearchConfig
if (!settings) settings = {};

const config = {
    url: settings.url || 'https://anysearch-backend.demo.ukrohost.com',
    customer_id: settings.customer_id
}

export default config